import styled from "styled-components";

export const ATLButton = styled.button`
  all: unset;
  border-radius: 20px;
  border: ${({ isClickable }) =>
    isClickable ? "1px solid rgba(0, 0, 0, 0.15)" : "1px solid transparent"};
  background: ${({ isClickable }) => (isClickable ? "#3b3b3b" : "transparent")};
  padding: 8px 16px;
  display: grid;
  place-content: center;
  width: 100%;
  box-sizing: border-box;
  cursor: ${({ isClickable }) => (isClickable ? "pointer" : "default")};

  &:hover {
    background-color: ${({ isClickable }) =>
      isClickable ? "rgba(59, 59, 59, 0.8)" : "transparent"};
  }
`;

export const Content = styled.div`
  display: flex;
  place-content: center;
  column-gap: 7px;
  color: ${({ isDisabled, theme }) =>
    isDisabled ? theme.text.title : "#fafafa"};
  line-height: 19px;
  font-size: 12px;
  font-family: "PP Formula";
`;

export const SpinnerContainer = styled.div`
  height: 20px;
  display: grid;
  place-content: center;
`;

export const Icon = styled.div`
  display: grid;
  place-content: center;
  width: 15px;
  height: 15px;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Container = styled.div`
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fbfbfa;
  box-shadow: 0px 1.171px 5.854px 0px rgba(63, 65, 66, 0.2);

  display: grid;
  place-content: center;
  padding: 8px;
  box-sizing: border-box;

  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 10;

  cursor: pointer;

  div:first-child {
    height: 20px;
  }
`;
